export default "__VITE_ASSET__GF0gItrS__"